<template>
	<div class="pushable">
		<navbar v-if="!$route.meta.hideNavbar" :count="count" :sidebar="sidebar" :toggleSidebar="toggleSidebar" />
		<sui-sidebar class="thin" v-model:visible="sidebar" dimmed inverted style="overflow: visible !important;">
			<template v-for="i in SIDEBAR_ITEMS">
				<sui-menu-item v-if="!i.items || i.items.length==0" @click="i.onClick()">
					{{ i.text }}
					<sui-label color="red" size="mini" v-if="i.badge && i.badge>0" style="margin-left: 5px;">{{i.badge}}</sui-label>
				</sui-menu-item>
				<sui-dropdown v-if="i.items && i.items.length>0" item :text="i.text">
					<sui-label color="red" size="mini" v-if="i.badge && i.badge>0" style="margin-left: 5px;">{{i.badge}}</sui-label>
					<sui-dropdown-menu>
						<sui-menu-item v-for="j in i.items" @click="j.onClick()">
							{{ j.text }}
							<sui-label color="red" size="mini" v-if="j.badge>0" style="margin-left: 5px;">{{j.badge}}</sui-label>
						</sui-menu-item>
					</sui-dropdown-menu>
				</sui-dropdown>
			</template>
			<!-- <sui-menu-item>
				<sui-icon name="home" />
				Home
			</sui-menu-item>
			<sui-menu-item>
				<sui-icon name="gamepad" />
				Games
			</sui-menu-item> -->
		</sui-sidebar>
		<div class="pusher" style="margin-top: 45px; padding-top: 10px; min-height: calc(100vh - 20px)">
			<sui-message warning v-if="isSlowNetwork" class="slow-network-banner">
				<sui-icon name="exclamation triangle" />
				Tu conexión a internet es lenta y puede afectar el funcionamiento del sistema.
			</sui-message>
			<router-view />
		</div>
		<AssistantWidget v-if="isSuperAdmin" />
	</div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, provide, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import Navbar from "@/users/components/Navbar.vue";
import AssistantWidget from "@/components/AssistantWidget.vue";
import Api from "./api/Api";
import Util from '../Util';
import { startNetworkSpeedMonitor } from "@/utils/networkSpeed";

export default {
	components: {
		Navbar,
		AssistantWidget,
	},
	setup () {
		const route = useRoute();
		// Assistant is superadmin-only (admin_type >= 12): the data path runs unrestricted SQL, so it must
		// not reach lower tiers. This hide is UX only — the /ai/assist backend enforces the same check.
		// Assistant reads tenant data, so megaadmins (>= 99) are excluded — the developer tier is
		// blind to business data. Only tenant superadmins (12..98) get it.
		// Read adminType INSIDE the computed: App.vue's setup() runs once (on the login page, before
		// adminType is set), so a captured const would stay stale until a refresh. The login route
		// change retriggers this computed, which then reads the freshly-written value.
		const isSuperAdmin = computed(() => {
			// Read `route` FIRST (unconditionally) so it's always a tracked reactive dependency — the
			// login navigation (/login → /home) is what re-runs this computed. If we short-circuited on
			// apiKey before touching route, route wouldn't be tracked and the bubble would only appear
			// after a manual refresh.
			const onPublicScreen = route.meta.hideNavbar;
			if (onPublicScreen || !localStorage.getItem('apiKey')) return false;
			const adminType = Util.decryptData(localStorage.getItem('adminType'));
			return adminType >= 12 && adminType < 99;
		});
		const count = ref(0);
        const page_name = process.env.VUE_APP_PAGE_NAME || 'Portal de Administración'
		const toast = useToast();
		const sidebar = ref(false);
		const SIDEBAR_ITEMS = ref([]);
		const isSlowNetwork = ref(false);
		let stopNetworkMonitor = null;
		
		const getPendingOrders = async () => {
			if(!localStorage.getItem('apiKey')) return false
			try {
				const res = await Api.getPendingClientCount();	
				if(res){
					if (!res.error) {
						const encryptOrdersCount = Util.encryptData(res.data[0].cuenta, process.env.VUE_APP_ENCRYPT_KEY);						
						localStorage.setItem('ordersCount', encryptOrdersCount);
						count.value = res.data[0].cuenta;
					} else {
						toast.error(res.message_client);
					}
				}
			} catch (err) {
				console.log('err', err);
				toast.error('Hubo un error al obtener los pedidos pendientes. (GPO-1)');
			}
		};

		const toggleSidebar = (items)=>{
			SIDEBAR_ITEMS.value = items;
			sidebar.value = !sidebar.value;
		}
		
		provide('count', count);
		provide('sidebar', sidebar);
		provide('getPendingOrders', getPendingOrders);
		provide('toggleSidebar', toggleSidebar);
		
		onMounted(() => {
			document.title = page_name;
			getPendingOrders();			
			if(process.env.VUE_APP_DEBUG!=='1'){
				setInterval(getPendingOrders, 2*60*1000);
			}
			stopNetworkMonitor = startNetworkSpeedMonitor((isSlow) => {
				isSlowNetwork.value = isSlow;
			});
		});

		onBeforeUnmount(() => {
			if (stopNetworkMonitor) stopNetworkMonitor();
		});
		
		return {
			count,
			sidebar,
			SIDEBAR_ITEMS,
			isSlowNetwork,
			isSuperAdmin,

			toggleSidebar,
			getPendingOrders
		}
	}
}
</script>

<style scoped>
	.ui.sidebar{
		top: 45px;
	}
	.slow-network-banner{
		margin: 0 15px 10px;
	}
</style>
